import React, { Component } from 'react';
import { bool, string, object, arrayOf, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import ImagePlaceholder from '../common/ImgPlaceholder/ImagePlaceholder';
import Testimonial from './Testimonial/Testimonial';

import styles from './TestimonialsBanner.css';

const cx = classnames.bind(styles);

class TestimonialsBanner extends Component {
  constructor(props) {
    super(props);

    this.totalPages = props.testimonials.length;
  }

  static propTypes = {
    autoplay: bool,
    className: string,
    colorScheme: oneOf(['lb01', 'lb02']),
    testimonials: arrayOf(object)
  }

  static defaultProps = {
    colorScheme: 'lb01',
  }

  state = {
    activePage: 1
  }

  handleCarousel = ({ currentPage }) => this.setState({ activePage: currentPage });

  render () {
    const { activePage } = this.state;
    const { className, testimonials, autoplay, colorScheme } = this.props;

    const collection = [null, ...testimonials];
    const { imageUrl, ...testimonial } = collection[activePage];

    return (
      <section className={cx(styles.wrapper, colorScheme, className)}>
        <ImagePlaceholder imageUrl={imageUrl} />
        <Testimonial
          autoplay={autoplay}
          totalPages={this.totalPages}
          currentPage={activePage}
          carouselHandler={this.handleCarousel}
          {...testimonial}
        />
        <div className={styles.testimonialBg} />
      </section>
    );
  }
}

export default TestimonialsBanner;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/TestimonialsBanner/TestimonialsBanner.js